import { LoginAdminApi } from "../../callApi/userAPi";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import Notiflix from "notiflix";
import React, { useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  const [cookies, setCookie] = useCookies(['TokenAdmin']);
  const router = useNavigate();

  const callLogin = async () =>{
    Notiflix.Loading.circle();
    let res = await LoginAdminApi({user:username,pass:password})
    Notiflix.Loading.remove();
    if(res.status == 200){
      setCookie('TokenAdmin',res.data.data.api_token)
      router("/admin/home");
    }else{
      Notiflix.Notify.failure('Error')
    }

  }
  return (
    <div className="flex flex-col items-center justify-center h-screen w-screen">
      <div className="drop-shadow-md p-3 bg-white  font-bold border">
        <p>Username</p>
        <CustomInput value={username} onChange={(v) => setusername(v)} />
        <p className="mt-3">Password</p>
        <CustomInput value={password} type="password" onChange={(v) => setpassword(v)}onEnter={()=>{
          if(username.length>0&&password.length>0){
            callLogin()
          }
        }} />
        <CustomButton
          onClick={() => {
            callLogin()
          }}
          txt={"Log in"}
          classAdditional="text-center mt-5   "
        />
      </div>
    </div>
  );
}
